import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import dates from './utils/dates';
import TimeSlotGroup from './TimeSlotGroup';

export default class TimeColumn extends Component {
  static propTypes = {
    step: PropTypes.number.isRequired,
    timeslots: PropTypes.number.isRequired,
    now: PropTypes.instanceOf(Date).isRequired,
    min: PropTypes.instanceOf(Date).isRequired,
    max: PropTypes.instanceOf(Date).isRequired,
    showLabels: PropTypes.bool,
    timeGutterFormat: PropTypes.string,
    className: PropTypes.string,
    style: PropTypes.object,
    children: PropTypes.node,
  }

  static defaultProps = {
    step: 30,
    timeslots: 2,
    showLabels: false,
    className: '',
  }

  // Helper function to calculate absolute difference in minutes between two dates
  absDiff = (date1, date2) => {
    // Use wall-clock day duration for grid rows to avoid DST day length
    // changing visible slot count (e.g. Nov fallback day).
    return 24 * 60;
  }

  renderTimeSliceGroup(key, isNow, date) {
    return (
      <TimeSlotGroup
        key={key}
        isNow={isNow}
        timeslots={this.props.timeslots}
        step={this.props.step}
        showLabels={this.props.showLabels}
        timeGutterFormat={this.props.timeGutterFormat}
        value={date}
      />
    );
  }

  render() {
    const totalMin = this.absDiff(this.props.min, this.props.max);
    const numGroups = Math.ceil(totalMin / (this.props.step * this.props.timeslots));
    const timeslots = [];
    const groupLengthInMinutes = this.props.step * this.props.timeslots;

    let date = this.props.min;
    let next = date;
    let isNow = false;

    for (let i = 0; i < numGroups; i++) {
      isNow = dates.inRange(
        this.props.now,
        date,
        dates.add(next, groupLengthInMinutes - 1, 'minutes'),
        'minutes'
      );

      next = dates.add(date, groupLengthInMinutes, 'minutes');
      timeslots.push(this.renderTimeSliceGroup(i, isNow, date));
      date = next;
    }

    return (
      <div
        className={cn(this.props.className, 'rbc-time-column')}
        style={this.props.style}
      >
        {timeslots}
        {this.props.children}
      </div>
    );
  }
}